var React = require('react');

function ReshotIconVideoPlayer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43.473,88.208a1.751,1.751,0,0,0,1.75,0l39.3-22.693a1.75,1.75,0,0,0,0-3.031l-39.3-22.693A1.75,1.75,0,0,0,42.6,41.307V86.693A1.751,1.751,0,0,0,43.473,88.208ZM46.1,44.338,80.152,64,46.1,83.662Z","key":0}),React.createElement("path",{"d":"M121.5,4.75H6.5A1.75,1.75,0,0,0,4.75,6.5v115a1.75,1.75,0,0,0,1.75,1.75h115a1.75,1.75,0,0,0,1.75-1.75V6.5A1.75,1.75,0,0,0,121.5,4.75ZM8.25,8.25h111.5V22.442H8.25Zm0,111.5V25.942h111.5V119.75Z","key":1}),React.createElement("path",{"d":"M101.654,106.528H54.589a3.975,3.975,0,0,0-7.162,0H26.346a1.75,1.75,0,1,0,0,3.5H47.427a3.975,3.975,0,0,0,7.162,0h47.065a1.75,1.75,0,0,0,0-3.5Z","key":2})]);
}

ReshotIconVideoPlayer.defaultProps = {"id":"Layer_1","data-name":"Layer 1","fill":"#BEA169","height":"46px","width":"46px","viewBox":"0 0 128 128"};

module.exports = ReshotIconVideoPlayer;

ReshotIconVideoPlayer.default = ReshotIconVideoPlayer;
